import PropTypes from "prop-types"
import styled from "styled-components"

const ContainerNoPadding = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
     &.justify-start {
    justify-content: flex-start;
    gap: 0px;
  }
    &.activity-graphics-container {
    justify-content: center;
    gap: 30px;
  }
  `}

  ${({ theme }) => theme.tablet`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    &.justify-start {
    justify-content: flex-start;
    gap: 0px;
  }
    &.activity-graphics-container {
    justify-content: flex-start;
    gap: 30px;
  }
  `}

  ${({ theme }) => theme.desktop`
    flex-direction: row;
    max-width: ${({ tight }) => (tight ? "800px" : "1200px")};
    align-items: ${({ alignTop }) => (alignTop ? "flex-start" : "center")};
    &.justify-start {
    justify-content: flex-start;
    gap: 60px;
  }
    &.activity-graphics-container {
    justify-content: center;
margin-left: 36px;
        gap: 29px;
  }
  `}

  ${({ theme }) => theme.largeDesktop`
  max-width: ${({ tight }) => (tight ? "1152px" : "1400px")};
  &.justify-start {
    justify-content: flex-start;
    gap: 60px;
  }
    &.activity-graphics-container {
    justify-content: center;
  //  margin-left: 46px;
  //       gap: 61px;
          margin-left: 33px;
        gap: 30px;
  }
  `}
`

ContainerNoPadding.propTypes = {
  alignTop: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  tight: PropTypes.bool,
}

ContainerNoPadding.defaultProps = {
  className: "",
  alignTop: false,
  tight: false,
}

export default ContainerNoPadding
